module.exports = __webpack_public_path__ + "img/sym5.4ceb5103.png";